var map = {
	"./cnn-money-x2.png": 2063,
	"./cnn-money.png": 2280,
	"./economist-x2.png": 2064,
	"./economist.png": 2281,
	"./mashable-x2.png": 2065,
	"./mashable.png": 2282,
	"./tech-crunch-x2.png": 2066,
	"./tech-crunch.png": 2283,
	"./thenewyorker-x2.png": 2067,
	"./thenewyorker.png": 2284,
	"./thrillist-x2.png": 2068,
	"./thrillist.png": 2285,
	"./time-x2.png": 2069,
	"./time.png": 2286,
	"./usa-today-x2.png": 2070,
	"./usa-today.png": 2287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2279;